import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_asilo-peramore/artifacts/qzmvlqzx_0945cabc-d0c0-4609-956c-55e1e91721a9.jpeg";

const links = [
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "progetto", label: "Progetto" },
  { id: "giornata", label: "Giornata Tipo" },
  { id: "gallery", label: "Gallery" },
  { id: "iscrizioni", label: "Iscrizioni" },
  { id: "calendario", label: "Calendario" },
  { id: "contatti", label: "Contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 bg-white ${
        scrolled ? "shadow-md" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-24">
        <button data-testid="nav-logo" onClick={() => go("hero")}>
          <img src={LOGO} alt="Logo Asilo Nido Per Amore" className="h-20 w-auto object-contain" />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="px-3 py-2 rounded-full text-sm font-700 text-slate-600 hover:text-rose-500 hover:bg-rose-50 transition-all"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden grid place-items-center h-11 w-11 rounded-full bg-rose-50 text-slate-700"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-slate-100 px-4 py-3 flex flex-col">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left px-4 py-3 rounded-2xl text-slate-700 font-700 hover:bg-rose-50 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
